import i18n from "./i18n.helper";

export function formatDateToDisplay(value, type = 'long') {
    try{
        if (value == "0001-01-01T01:00:00+01:00" || value == undefined || value == null || !value)
        return "--";

        const date = new Date(value)
        return i18n.global.d(date, type);
    }
    catch{
        return "--";
    }
}